import {
  type SupportAttachment,
  type SupportAttachmentApiResource,
  type SupportAttachmentInit,
  type SupportAttachmentInitApiResource,
  type SupportMessage,
  type SupportMessageApiResource,
  type SupportTicket,
  type SupportTicketApiResource,
  type SupportTicketDetail,
  type SupportTicketDetailApiResource,
  type SupportTicketEvent,
  type SupportTicketEventApiResource,
} from './supportApi.types';

const MEDIA_PREVIEW_TRANSLATION_KEY_BY_BACKEND_KEY: Record<string, string> = {
  'support.preview.media_image': 'support:preview.mediaImage',
  'support.preview.media_video': 'support:preview.mediaVideo',
  'support.preview.media_document': 'support:preview.mediaDocument',
};

export function mapApiResourceToSupportAttachment(
  resource: SupportAttachmentApiResource
): SupportAttachment {
  return {
    id: resource.id,
    filename: resource.filename,
    contentType: resource.content_type,
    sizeBytes: resource.size_bytes,
    width: resource.width,
    height: resource.height,
    mediaKind: resource.media_kind,
    status: resource.status,
    downloadUrl: resource.download_url,
    thumbnailUrl: resource.thumbnail_url,
  };
}

export function mapApiResourceToSupportMessage(resource: SupportMessageApiResource): SupportMessage {
  return {
    id: resource.id,
    ticketId: resource.ticket_id,
    senderKind: resource.sender_kind,
    senderName: resource.sender_name,
    body: resource.body,
    attachments: resource.attachments.map(mapApiResourceToSupportAttachment),
    createdAt: resource.created_at,
  };
}

export function mapApiResourceToSupportTicketEvent(
  resource: SupportTicketEventApiResource
): SupportTicketEvent {
  return {
    id: resource.id,
    eventType: resource.event_type,
    actorName: resource.actor_name,
    actorKind: resource.actor_kind,
    fromStatus: resource.from_status,
    toStatus: resource.to_status,
    detail: resource.detail,
    createdAt: resource.created_at,
  };
}

export function mapApiResourceToSupportTicket(resource: SupportTicketApiResource): SupportTicket {
  return {
    id: resource.id,
    subject: resource.subject,
    category: resource.category,
    priority: resource.priority,
    status: resource.status,
    tenantId: resource.tenant_id,
    tenantName: resource.tenant_name,
    createdByName: resource.created_by_name,
    assigneeUserId: resource.assignee_user_id,
    assigneeName: resource.assignee_name,
    lastMessagePreview: resource.last_message_preview,
    lastMessageAt: resource.last_message_at,
    lastMessageSenderKind: resource.last_message_sender_kind,
    unreadCount: resource.unread_count,
    isSendEnabled: resource.is_send_enabled,
    createdAt: resource.created_at,
    assignedAt: resource.assigned_at,
    resolvedAt: resource.resolved_at,
    closedAt: resource.closed_at,
  };
}

export function mapApiResourceToSupportTicketDetail(
  resource: SupportTicketDetailApiResource
): SupportTicketDetail {
  return {
    ...mapApiResourceToSupportTicket(resource),
    events: resource.events.map(mapApiResourceToSupportTicketEvent),
  };
}

export function mapApiResourceToSupportAttachmentInit(
  resource: SupportAttachmentInitApiResource
): SupportAttachmentInit {
  return {
    attachmentId: resource.attachment_id,
    uploadUrl: resource.upload_url,
    contentType: resource.content_type,
    method: resource.method,
  };
}

export function resolveSupportPreviewTranslationKey(preview: string | null): string | null {
  if (preview === null) {
    return null;
  }
  const translationKey = MEDIA_PREVIEW_TRANSLATION_KEY_BY_BACKEND_KEY[preview];
  return translationKey === undefined ? null : translationKey;
}
